<div class="site-wrapper">
  <router-outlet></router-outlet>
</div>